import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../core/content-container/content-container';

@Component({
  selector: 'app-politica-de-privacidade',
  imports: [ContentContainer],
  templateUrl: './politica-de-privacidade.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoliticaDePrivacidadeComponent {}
